import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  CardActions,
  Button,
  Alert,
} from "@mui/material";
import { useLocation, useParams } from "react-router";
import { checkTokenStatus, resendEmail, verifyEmail } from "../../network/apis/auth.api";
import { useAuth0 } from "@auth0/auth0-react";

const ConfirmEmail = () => {
  const { loginWithRedirect } = useAuth0();
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");
  const [emailSuccess, setEmailSuccess] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [tokenStatus, setTokenStatus] = useState(true);
 

  useEffect(() => {
    const fetchTokenStatus = async () => {
      try {
        const data = await checkTokenStatus(token);
        setTokenStatus(data);
      } catch (error) {
      }
    };
  
    fetchTokenStatus();
  }, [token, email]);
  
  const handleConfirmClick = async () => {
    try {
      const response = await verifyEmail(id);
  
      if (response.status === 200) {
        setIsEmailVerified(true);
      } else {
      }
    } catch (error) {
    }
  };
  
  const handleResendEmail = async () => {
    try {
      const response = await resendEmail(email, id);
  
      if (response.status === 200) {
        setEmailSuccess(
          "Resend email successfully, please check your email and confirm"
        );
      } else {
        //console.log("Email resend failed with status:", response.status);
      }
    } catch (error) {
      //console.error("Error resending email:", error);
    }
  };
  
  const handleBack = () => {
    loginWithRedirect()
  };
  
  return (
    <>
      {tokenStatus === false ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card sx={{ maxWidth: 600, padding: 5, marginTop: 2 }}>
            {emailSuccess && (
              <Alert severity="success" fullWidth>
                {emailSuccess}
              </Alert>
            )}
            <CardActionArea>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  Verification link has expired
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Please Click the button below to resend a verification email
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={handleResendEmail}
              >
                Resend Email
              </Button>
            </CardActions>
          </Card>
        </Box>
      ) : (
        <>
          {tokenStatus === true ? (
            isEmailVerified ? (
              <Alert
                severity="success"
                variant="outlined"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: 10,
                  marginRight: 10,
                  color: "green",
                  backgroundColor: "#ffffff",
                }}
                action={
                  <Button color="inherit" size="small" onClick={handleBack}>
                    Back to Login
                  </Button>
                }
              >
                Your email has been verified!
              </Alert>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Card sx={{ maxWidth: 600, padding: 5, marginTop: 2 }}>
                  <CardActionArea>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Confirm Your Email
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Please click the button below to verify your email
                        address
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      color="primary"
                      variant="contained"
                      onClick={handleConfirmClick}
                    >
                      Confirm
                    </Button>
                  </CardActions>
                </Card>
              </Box>
            )
          ) : null}
        </>
      )}
    </>
  );
};

export default ConfirmEmail;
